import { Icon, IconButton, Paper, Switch, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import {} from "assets/jss/material-dashboard-react.js";
import api from "axios.js";
import axios from "axios";
import Button from "components/CustomButtons/Button.js";
import Form from "components/MuiJsonForm";
import MaterialTable from "components/MaterialTable.js";
import moment from "moment";
import "moment/locale/fr";
import PubSub from "pubsub-js";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Actions from "redux/actions";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import {
  etatColumns,
  quitanceColumns,
  quitanceGenerateColumns,
} from "utils/columns";
import { quitanceSchema } from "utils/schemas";
import downloadFile from "utils/downloadFile";
moment.locale("fr");

const RedRadio = withStyles({
  root: {
    color: "#f59673",
    "&$checked": {
      color: "#f59673",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const GreenRadio = withStyles({
  root: {
    color: "#6ac47b ",
    "&$checked": {
      color: "#6ac47b",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const GENERATED_ROW_STYLE = { backgroundColor: "#6ac47b" };
const SELECTED_ROW_STYLE = { backgroundColor: "#aebfe8" };
const DEFAULT_ROW_STYLE = { backgroundColor: "#f59673" };
const DETAIL_PANEL_STYLE = { margin: 10 };
const PAPER_STYLE = { marginBottom: 10, padding: 10 };
const MONTH_LABEL_STYLE = { width: 200, textAlign: "center", margin: 0, padding: 0 };
const LECTURE_ACTIVE_STYLE = { color: "green", fontWeight: "bold" };
const LECTURE_INACTIVE_STYLE = { color: "unset", fontWeight: "unset" };
const GENERATION_ACTIVE_STYLE = { color: "green", fontWeight: "bold" };
const GENERATION_INACTIVE_STYLE = { color: "unset", fontWeight: "unset" };


const ManualQuitanceForm = React.memo(
  ({ dossier, initialData, onDraftChange, onSubmitRequest, visible }) => {
    const [formData, setFormData] = React.useState(initialData);

    React.useEffect(() => {
      setFormData(initialData);
    }, [initialData]);

    const schemaConfig = React.useMemo(
      () => quitanceSchema(dossier, false, true),
      [dossier?.id]
    );

    const handleChange = React.useCallback(
      ({ formData }) => {
        setFormData(formData);
        if (onDraftChange) {
          onDraftChange(formData);
        }
      },
      [onDraftChange]
    );

    const handleSubmit = React.useCallback(
      ({ formData }) => {
        if (onSubmitRequest) {
          onSubmitRequest(formData);
        }
      },
      [onSubmitRequest]
    );

    const total = React.useMemo(() => {
      const values = formData?.data || {};
      const prixHC = parseFloat(values.prixHC) || 0;
      const charge = parseFloat(values.charge) || 0;
      return (prixHC + charge).toFixed(2);
    }, [formData]);

    if (!visible) {
      return null;
    }

    return (
      <Form
        {...schemaConfig}
        formData={formData}
        onChange={handleChange}
        onSubmit={handleSubmit}
      >
        <Typography>{`Loyer total: ${total} EUR`}</Typography>
      </Form>
    );
  }
);

class FormList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      load: true,
      quitances: [],
      dossiers: [],
      dossiersLoading: true,
      generate: false,
      isGenerating: false,
      date: new Date(),
      dialog: false,
      auto: "all",
      checked: [],
      etatVersion: 0,
      page: 0,
      pageSize: 25,
      totalCount: undefined,
      generatedIds: undefined,
      tableVersion: 0,
    };
    this.dispatch = this.props.dispatch;
    this.overrides = {};
    this.cancelSources = new Set();
    this.manualDraftChangeHandlers = new Map();
    this.manualSubmitHandlers = new Map();
    this.monthMetaCache = {};
    this.listTableRef = React.createRef();
    this._isMounted = false;
    this.actionsCache = null;
    this.actionsCacheKey = null;
    this.etatCache = new Map();
    this.etatLoading = new Set();
  }

  componentDidMount() {
    this._isMounted = true;
    this.getQuitances();
    this.loadGeneratedIds();
    this.loadDossiersData(this.state.date);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.cancelAllRequests("QuitancesList unmounted");
    this.etatCache.clear();
    this.etatLoading.clear();
    if (typeof PubSub.close === "function") {
      try {
        PubSub.close();
      } catch (e) {
        console.warn("Unable to close PubSub dialogs on unmount", e);
      }
    }
  }

  updateState = (updater, callback) => {
    if (this._isMounted) {
      this.setState(updater, callback);
    }
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  apiGet = (url, options = {}) => {
    const source = this.createCancelSource();
    return api
      .get(url, { ...options, cancelToken: source.token })
      .finally(() => this.releaseCancelSource(source));
  };

  apiPost = (url, data, options = {}) => {
    const source = this.createCancelSource();
    return api
      .post(url, data, { ...options, cancelToken: source.token })
      .finally(() => this.releaseCancelSource(source));
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  etatTableOptions = {
    actionsColumnIndex: -1,
    filtering: false,
    header: false,
    toolbar: false,
    search: false,
    paging: false,
  };

  listTableOptions = {
    actionsColumnIndex: -1,
    pageSize: 20,
    filtering: true,
    exportAllData: false,
  };

  rowClickNoop = () => null;

  getGenerateRowStyle = (rowData) => {
    if (this.state.generatedIds?.has(rowData.id)) return GENERATED_ROW_STYLE;
    if (this.state.checked.includes(rowData.id)) return SELECTED_ROW_STYLE;
    return DEFAULT_ROW_STYLE;
  };

  rowStyleGenerate = (rowData) => this.getGenerateRowStyle(rowData);

  generateTableOptions = {
    actionsColumnIndex: -1,
    filtering: true,
    selection: true,
    paging: false,
    rowStyle: this.rowStyleGenerate,
  };

  handleGenerateSelectionChange = (rows) => {
    this.setState({ checked: rows.map((r) => r.id) });
  };

  loadGeneratedIds = () => {
    const formattedDate = this.formatSelectedMonth();
    return this.apiGet(`Quitance/byDateIds/${formattedDate}`)
      .then(({ data }) => {
        const ids = Array.isArray(data?.ids) ? data.ids : [];
        const generatedIds = new Set(
          ids.filter((id) => id !== null && id !== undefined)
        );
        this.updateState({ generatedIds });
        return generatedIds;
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        console.error("Unable to load generated ids", error);
        this.updateState({ generatedIds: new Set() });
      });
  };

  renderEtatPanel = (row) => (
    (() => {
      const cached = this.etatCache.get(row.id);
      if (!cached && !this.etatLoading.has(row.id)) {
        this.etatLoading.add(row.id);
        this.apiGet(`Quitance/${row.id}`)
          .then(({ data }) => {
            if (data && Array.isArray(data.Etats)) {
              this.etatCache.set(row.id, data.Etats);
            } else {
              this.etatCache.set(row.id, []);
            }
          })
          .catch((error) => {
            if (axios.isCancel(error)) return;
            console.error("Unable to load états de quittance", error);
            this.etatCache.set(row.id, []);
          })
          .finally(() => {
            this.etatLoading.delete(row.id);
            this.updateState({ etatVersion: Date.now() });
          });
      }
      const data = cached || [];
      const isLoading = this.etatLoading.has(row.id);
      return (
        <MaterialTable
          title=""
          columns={etatColumns}
          data={data}
          isLoading={isLoading}
          onRowClick={this.rowClickNoop}
          options={this.etatTableOptions}
        />
      );
    })()
  );

  renderGenerateDetail = (row) => {
    const alreadyGenerated = this.state.quitances.find(
      (d) => d.DossierId === row.id
    );
    if (alreadyGenerated) {
      return (
        <div style={DETAIL_PANEL_STYLE}>
          <Typography>
            {"Ce dossier possède déjà une quittance pour ce mois."}
          </Typography>
        </div>
      );
    }
    if (this.state.checked.includes(row.id)) {
      return (
        <div style={DETAIL_PANEL_STYLE}>
          <Typography>
            {
              "Ce dossier est sélectionné pour la génération automatique."
            }
          </Typography>
        </div>
      );
    }
    const isOpen =
      row?.tableData?.showDetailPanel === true ||
      Boolean(row?.tableData?.showDetailPanel);
    return (
      <div style={DETAIL_PANEL_STYLE}>
        <ManualQuitanceForm
          dossier={row}
          initialData={this.getFormDataForRow(row)}
          onDraftChange={this.getManualDraftChangeHandler(row.id)}
          onSubmitRequest={this.getManualSubmitHandler(row.id)}
          visible={isOpen}
        />
      </div>
    );
  };

  formatSelectedMonth = () => {
    const { date } = this.state;
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    return `${month}-${date.getFullYear()}`;
  };

  getMonthMeta = () => {
    const { date } = this.state;
    const timeValue = date?.getTime?.() || 0;
    if (this.monthMetaCache.timeValue !== timeValue) {
      const monthMoment = moment(date);
      this.monthMetaCache = {
        timeValue,
        startMonth: monthMoment.clone().startOf("month"),
        endMonth: monthMoment.clone().endOf("month"),
        monthKey: monthMoment.format("YYYY-MM"),
        monthLabel: monthMoment.format("MMMM YYYY"),
        downloadMonthPath: monthMoment.format("YYYY/MM"),
        downloadMonthLabel: monthMoment.format("MMMM_YYYY"),
      };
    }
    return this.monthMetaCache;
  };

  getDefaultFormData = (row) => {
    const currentMonth = moment(this.state.date);
    return {
      data: {
        date: currentMonth.clone().startOf("month").format("YYYY-MM-DD"),
        dateFin: currentMonth.clone().endOf("month").format("YYYY-MM-DD"),
        prixHC: row?.loyerHC || 0,
        charge: row?.loyerCharge || 0,
      },
    };
  };

  getFormDataForRow = (row) => {
    return this.overrides[row.id] || this.getDefaultFormData(row);
  };

  resetOverrides = (ids = []) => {
    if (!ids.length) return;
    ids.forEach((id) => {
      if (this.overrides[id]) {
        delete this.overrides[id];
      }
    });
  };

  buildOverridesPayload = (ids) => {
    const overrides = {};
    ids.forEach((id) => {
      const data = this.overrides[id]?.data;
      if (data) overrides[id] = data;
    });
    return overrides;
  };

  updateOverrideDraft = (dossierId, formData) => {
    if (!formData) return;
    this.overrides[dossierId] = formData;
  };

  getManualDraftChangeHandler = (dossierId) => {
    if (!this.manualDraftChangeHandlers.has(dossierId)) {
      this.manualDraftChangeHandlers.set(dossierId, (formData) =>
        this.updateOverrideDraft(dossierId, formData)
      );
    }
    return this.manualDraftChangeHandlers.get(dossierId);
  };

  getManualSubmitHandler = (dossierId) => {
    if (!this.manualSubmitHandlers.has(dossierId)) {
      this.manualSubmitHandlers.set(dossierId, (formData) => {
        if (!formData) return;
        this.setState({
          dialog: {
            type: "manual",
            dossierId,
            ...formData.data,
            onClick: () =>
              this.apiPost(`Quitance/generate/manual/${dossierId}`, {
                ...formData.data,
              })
                .then(() => {
                  this.resetOverrides([dossierId]);
                  return this.getQuitances();
                })
                .catch((error) => {
                  if (axios.isCancel(error)) return;
                  console.error("Manual quitance failed", error);
                  PubSub.notif({
                    txt: "Impossible de générer cette quittance.",
                    color: "danger",
                  });
                }),
          },
        });
      });
    }
    return this.manualSubmitHandlers.get(dossierId);
  };

  getQuitances = () => {
    const formattedDate = this.formatSelectedMonth();
    this.setState({ load: true, quitances: [] });
    const params = {
      page: this.state.page || 0,
      pageSize: this.state.pageSize || 20,
    };
    return this.apiGet(`Quitance/byDateLite/${formattedDate}`, { params })
      .then(({ data }) => {
        this.etatCache.clear();
        this.etatLoading.clear();
        const payload = data && data.data ? data.data : data;
        const quitances = Array.isArray(payload)
          ? payload.map((q) => {
              const { Etats, ...rest } = q || {};
              return rest;
            })
          : [];
        const totalCount =
          typeof data?.totalCount === "number" ? data.totalCount : undefined;
        const page =
          typeof data?.page === "number" ? data.page : params.page || 0;
        const pageSize =
          typeof data?.pageSize === "number"
            ? data.pageSize
            : params.pageSize || 20;
        this.updateState({
          quitances,
          load: false,
          totalCount,
          page,
          pageSize,
        });
        this.loadGeneratedIds();
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        console.error("Unable to load quitances", error);
        this.updateState({ load: false });
        PubSub.notif({
          txt: "Impossible de charger les quittances pour ce mois.",
          color: "danger",
        });
      });
  };

  fetchQuitancesForTable = (query) => {
    const requestedPage = query?.page || 0;
    const nextPageSize = query?.pageSize || this.state.pageSize || 20;
    const formattedDate = this.formatSelectedMonth();
    const search = query?.search?.trim();
    const orderBy = query?.orderBy?.field;
    const orderDirection = query?.orderDirection;
    const filters =
      Array.isArray(query?.filters) && query.filters.length
        ? query.filters
            .filter((f) => f?.value)
            .map((f) => ({ field: f?.column?.field, value: f.value }))
        : undefined;
    const fetchPage = (pageToFetch, clamped = false) =>
      this.apiGet(`Quitance/byDateLite/${formattedDate}`, {
        params: {
          page: pageToFetch,
          pageSize: nextPageSize,
          search: search || undefined,
          orderBy: orderBy || undefined,
          orderDirection: orderDirection || undefined,
          filters: filters ? JSON.stringify(filters) : undefined,
          auto:
            this.state.auto === "auto"
              ? "auto"
              : this.state.auto === "manual"
              ? "manual"
              : undefined,
        },
      })
        .then(({ data }) => {
          this.etatCache.clear();
          this.etatLoading.clear();
          const payload = data && data.data ? data.data : data;
          const quitances = Array.isArray(payload)
            ? payload.map((q) => {
                const { Etats, ...rest } = q || {};
                return rest;
              })
            : [];
          const totalCount =
            typeof data?.totalCount === "number"
              ? data.totalCount
              : quitances.length;
          const realMaxPage =
            totalCount > 0
              ? Math.max(Math.ceil(totalCount / nextPageSize) - 1, 0)
              : 0;
          if (!clamped && pageToFetch > realMaxPage) {
            const safePage = Math.min(pageToFetch, realMaxPage);
            this.setState({
              page: safePage,
              pageSize: nextPageSize,
            });
            return fetchPage(safePage, true);
          }
          this.updateState({
            quitances,
            totalCount,
            page: pageToFetch,
            pageSize: nextPageSize,
            load: false,
          });
          this.loadGeneratedIds();
          return {
            data: quitances,
            page: pageToFetch,
            totalCount,
          };
        })
        .catch((error) => {
          if (axios.isCancel(error))
            return { data: [], page: 0, totalCount: 0 };
          console.error("Unable to load quitances", error);
          PubSub.notif({
            txt: "Impossible de charger les quittances pour ce mois.",
            color: "danger",
          });
          return { data: [], page: 0, totalCount: 0 };
        });

    return fetchPage(requestedPage);
  };

  refreshListData = () => {
    if (this.listTableRef?.current?.onQueryChange) {
      this.listTableRef.current.onQueryChange();
    } else {
      this.getQuitances();
    }
  };

  updateQuitanceInState = (updated) => {
    if (!updated || !updated.id) {
      this.getQuitances();
      return;
    }
    this.updateState((state) => ({
      quitances: state.quitances.map((q) =>
        q.id === updated.id ? { ...q, ...updated } : q
      ),
    }));
  };

  applyStatusUpdate = (promise) => {
    if (!promise || typeof promise.then !== "function") return;
    promise
      .then(({ data }) => {
        if (data?.quitance) this.updateQuitanceInState(data.quitance);
        else this.getQuitances();
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        console.error("Unable to update quitance status", error);
        this.getQuitances();
      });
  };

  loadDossiersData = async (targetDate) => {
    const selectedDate = targetDate || this.state.date || new Date();
    const monthKey = moment(selectedDate).format("YYYY-MM");
    this.setState({ dossiersLoading: true });
    try {
      const { data: summariesResponse } = await this.apiGet("Dossier/summaries", {
        params: { month: monthKey },
      });
      const summaries = Array.isArray(summariesResponse)
        ? summariesResponse
        : [];
      const unique = (values) =>
        Array.from(
          new Set(
            values.filter(
              (value) => value !== undefined && value !== null && value !== ""
            )
          )
        );
      const appartementIds = unique(
        summaries.map(
          (dossier) => dossier.AppartementId || dossier.appartementId
        )
      );
      const locataireIds = unique(
        summaries.map(
          (dossier) => dossier.LocataireId || dossier.locataireId
        )
      );
      const [appartementResponse, locataireResponse] = await Promise.all([
        appartementIds.length
          ? this.apiGet("Dossier/appartements/byIds", {
              params: { ids: appartementIds.join(",") },
            })
          : Promise.resolve({ data: [] }),
        locataireIds.length
          ? this.apiGet("Dossier/locataires/byIds", {
              params: { ids: locataireIds.join(",") },
            })
          : Promise.resolve({ data: [] }),
      ]);
      const appartements = Array.isArray(appartementResponse.data)
        ? appartementResponse.data
        : [];
      const locataires = Array.isArray(locataireResponse.data)
        ? locataireResponse.data
        : [];
      const proprietaireIds = unique(
        appartements.reduce((acc, appartement) => {
          const ids = Array.isArray(appartement.proprietaireIds)
            ? appartement.proprietaireIds
            : [];
          return acc.concat(ids);
        }, [])
      );
      const clientsResponse = proprietaireIds.length
        ? await this.apiGet("Dossier/clients/byIds", {
            params: { ids: proprietaireIds.join(",") },
          })
        : { data: [] };
      const clients = Array.isArray(clientsResponse.data)
        ? clientsResponse.data
        : [];
      const clientMap = new Map(clients.map((client) => [client.id, client]));
      const appartementMap = new Map(
        appartements.map((appartement) => [
          appartement.id,
          {
            ...appartement,
            proprietaires: (appartement.proprietaireIds || [])
              .map((id) => clientMap.get(id))
              .filter(Boolean),
          },
        ])
      );
      const locataireMap = new Map(
        locataires.map((locataire) => [locataire.id, locataire])
      );
      const dossiers = summaries.map((dossier) => ({
        ...dossier,
        Appartement:
          appartementMap.get(dossier.AppartementId || dossier.appartementId) ||
          null,
        Locataire:
          locataireMap.get(dossier.LocataireId || dossier.locataireId) || null,
      }));
      this.updateState({ dossiers, dossiersLoading: false });
    } catch (error) {
      if (axios.isCancel(error)) return;
      console.error("Unable to load dossier summaries", error);
      PubSub.notif({
        txt: "Impossible de charger la liste des dossiers.",
        color: "danger",
      });
      this.updateState({ dossiers: [], dossiersLoading: false });
    }
  };

  getActions = () => {
    if (this.actionsCache && this.actionsCacheKey === this.props.canDelete) {
      return this.actionsCache;
    }
    const { downloadMonthPath, downloadMonthLabel } = this.getMonthMeta();
    const actions = [
      {
        icon: "swap_horiz",
        tooltip: "Changer le statut de paiement",
        onClick: (event, rowData) =>
          PubSub.confirm({
            title: `Changer l'état de la quittance`,
            subtitle: "Dans quel état voulez vous faire passer la quittance ?",
            buttons: [
              {
                txt: "Payé",
                onClick: (_) =>
                  this.applyStatusUpdate(
                    this.apiGet(`Quitance/switchState/true/${rowData.id}`)
                  ),
              },
              {
                txt: "Impayé",
                onClick: (_) =>
                  this.applyStatusUpdate(
                    this.apiGet(`Quitance/switchState/false/${rowData.id}`)
                  ),
              },
              {
                txt: "Inconnu",
                onClick: (_) =>
                  this.applyStatusUpdate(
                    this.apiGet(`Quitance/switchState/unknown/${rowData.id}`)
                  ),
              },
            ].filter(
              (b) =>
                (b.txt !== "Inconnu" && rowData.statusInconu) ||
                (!(b.txt === "Payé" && rowData.regle) &&
                  !(b.txt === "Impayé" && !rowData.regle) &&
                  !(b.txt === "Inconnu" && rowData.statusInconu))
            ),
          }),
      },
      {
        icon: () => (
          <Button color="primary">Télécharger les quittances du mois</Button>
        ),
        onClick: (_) =>
          downloadFile(
            `Quitance/downloadMonth/${downloadMonthPath}`,
            `Quittances ${downloadMonthLabel}.zip`
          ),
        isFreeAction: true,
      },
      {
        icon: "assignment_returned",
        tooltip: "Télécharger la quittance",
        onClick: (event, rowData) =>
          downloadFile(
            rowData.file,
            `Quittance_${rowData.numero}_${moment(rowData.date).format("MMMM_YYYY")}-${rowData.Locataire.nom}-${rowData.DossierId}.pdf`
          ),
      },
      {
        icon: "home",
        tooltip: "Voir l'appartement",
        onClick: (event, rowData) =>
          this.props.history.push(`/appartements/${rowData.Appartement.id}`),
      },
      {
        icon: "assignment_ind",
        tooltip: "Voir le client",
        onClick: (event, rowData) =>
          this.props.history.push(`/client/${rowData.Client.id}`),
      },
      {
        icon: "supervised_user_circle",
        tooltip: "Voir le locataire",
        onClick: (event, rowData) =>
          this.props.history.push(`/locataires/${rowData.Locataire.id}`),
      },
      this.props.canDelete && {
        icon: "delete",
        tooltip: "Supprimer la quittance",
        onClick: (event, rowData) =>
          PubSub.confirm({
            title: "Supprimer l'élément ?",
            subtitle: "Cette action est irréversible.",
            onAgree: (_) =>
              this.dispatch(Actions.deleteQuitance(rowData.id)).then((_) =>
                this.getQuitances()
              ),
          }),
      },
    ].filter(Boolean);
    this.actionsCache = actions;
    this.actionsCacheKey = this.props.canDelete;
    return this.actionsCache;
  };

  getFilteredQuitances = () => {
    const { auto } = this.state;
    return this.state.quitances.filter((q) => {
      if (auto === "auto" && !q.automatique) return false;
      if (auto === "manual" && q.automatique) return false;
      return true;
    });
  };

  changeMonth = (delta) => {
    const current = this.state.date || new Date();
    const nextDate = moment(current).add(delta, "month").toDate();
    this.cancelAllRequests("change month");
    this.etatCache.clear();
    this.etatLoading.clear();
    this.actionsCache = null;
    this.actionsCacheKey = null;
    this.overrides = {};
    this.manualDraftChangeHandlers.clear();
    this.manualSubmitHandlers.clear();
    this.monthMetaCache = {};
    this.setState(
      {
        date: nextDate,
        checked: [],
        dialog: false,
        quitances: [],
        page: 0,
        generatedIds: undefined,
        totalCount: undefined,
        tableVersion: (this.state.tableVersion || 0) + 1,
      },
      () => {
        this.refreshListData();
        this.loadDossiersData(nextDate);
      }
    );
  };

  getDossiersForMonth = (startMonth, endMonth) => {
    if (!Array.isArray(this.state.dossiers)) return [];
    return this.state.dossiers.filter((dossier) => {
      if (!dossier || !dossier.dateDebutBail) return false;
      const startDate = moment(dossier.dateDebutBail);
      if (!startDate.isValid()) return false;
      const endDate =
        dossier.dateFinBail && dossier.dateFinBail !== "0000-00-00"
          ? moment(dossier.dateFinBail)
          : null;
      const startOk = startDate.isSameOrBefore(endMonth, "day");
      const endOk =
        !endDate || !endDate.isValid()
          ? true
          : endDate.isSameOrAfter(startMonth, "day");
      return startOk && endOk;
    });
  };

  generateAutoQuitance = () => {
    const generatedSet = this.state.generatedIds || new Set();
    const selectableIds = this.state.checked.filter((id) => !generatedSet.has(id));
    if (!selectableIds.length) {
      return PubSub.notif({
        txt: "Aucune quittance à générer pour la sélection courante.",
        color: "warning",
      });
    }
    this.setState({ isGenerating: true });
    const payload = {
      date: this.formatSelectedMonth(),
      dossierIds: selectableIds,
    };
    const overrides = this.buildOverridesPayload(selectableIds);
    if (Object.keys(overrides).length) {
      payload.overrides = overrides;
    }

    this.apiPost("Quitance/generateBatch", payload)
      .then(({ data }) => {
        const generated = data?.generated?.length || 0;
        const errors = data?.errors?.length || 0;
        const skipped = data?.skipped?.length || 0;
        const parts = [];
        if (generated) parts.push(`${generated} quittance(s) générée(s)`);
        if (skipped) parts.push(`${skipped} sautée(s)`);
        if (errors) parts.push(`${errors} en erreur`);
        PubSub.notif({
          txt:
            parts.length > 0
              ? `Batch quittances: ${parts.join(", ")}`
              : "Batch traitée.",
          color: errors ? "warning" : "success",
        });
        if (data?.errors?.length) {
          console.error("Batch errors", data.errors);
        }
        if (generated && data?.generated) {
          const ids = data.generated.map((item) => item.dossierId);
          this.resetOverrides(ids);
          const generatedSet = new Set(this.state.generatedIds || []);
          ids.forEach((id) => generatedSet.add(id));
          this.updateState({ generatedIds: generatedSet });
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        console.error("Batch generation failed", error);
        const message =
          error?.response?.data?.error ||
          "Impossible de générer les quittances sélectionnées.";
        PubSub.notif({
          txt: message,
          color: "danger",
        });
      })
      .finally(() => {
        if (!this._isMounted) return;
        this.getQuitances().finally((_) =>
          this.updateState({ isGenerating: false })
        );
      });
  };

  GenerateAutoButton = () => {
    if (!this.state.generate) return null;
    if (this.state.dossiersLoading || this.state.isGenerating)
      return <CircularProgress />;
    return (
      <Button
        color="primary"
        onClick={(_) => {
          this.setState({
            dialog: { type: "auto", onClick: this.generateAutoQuitance },
          });
        }}
      >
        Générer les quittances automatiques
      </Button>
    );
  };

  render() {
    const c = this.props.classes;
    const { generate, dialog } = this.state;
    const {
      endMonth,
      startMonth,
      monthKey,
      monthLabel,
    } = this.getMonthMeta();
    return (
      <div className={c.container}>
        {false && (
          <Button
            onClick={(_) =>
              this.apiPost(`Quitance/generate/4`, {
                date: this.state.date.toISOString(),
              }).then((rep) => {
                console.log(rep);
                downloadFile(rep.data.file, `quittance.pdf`);
              })
            }
          >
            TEST
          </Button>
        )}
        <Paper style={PAPER_STYLE}>
          <div className="row, fullW, justify-o">
            {generate ? (
              <FormControl component="fieldset">
                <FormLabel component="legend">Légende</FormLabel>
                <RadioGroup
                  className="row"
                  aria-label="gender"
                  name="auto"
                  value={this.state.auto}
                  onChange={(e) => this.setState({ auto: e.target.value })}
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio checked={true} />}
                    label="Automatique"
                  />
                  <FormControlLabel
                    value="auto"
                    control={<RedRadio checked={true} />}
                    label="Manuelle"
                  />
                  <FormControlLabel
                    value="auto"
                    control={<GreenRadio checked={true} />}
                    label="Générée"
                  />
                </RadioGroup>
              </FormControl>
            ) : (
              <FormControl component="fieldset">
                <FormLabel component="legend">Gestion des paiements</FormLabel>
                <RadioGroup
                  className="row"
                  aria-label="gender"
                  name="auto"
                  value={this.state.auto}
                  onChange={(e) => this.setState({ auto: e.target.value })}
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio />}
                    label="Toutes"
                  />
                  <FormControlLabel
                    value="auto"
                    control={<Radio />}
                    label="Automatiques"
                  />
                  <FormControlLabel
                    value="manual"
                    control={<Radio />}
                    label="Manuelles"
                  />
                </RadioGroup>
              </FormControl>
            )}
            <div className="row align-c">
              <p
                style={generate ? LECTURE_INACTIVE_STYLE : LECTURE_ACTIVE_STYLE}
              >
                Lecture
              </p>
              <Switch
                checked={generate}
                onChange={(_) => this.setState({ generate: !generate })}
                name="checkedA"
              />
              <p
                style={generate ? GENERATION_ACTIVE_STYLE : GENERATION_INACTIVE_STYLE}
              >
                Génération
              </p>
            </div>
          </div>
          <div className="row fullW justify-c align-c">
            <IconButton
              onClick={(_) => this.changeMonth(-1)}
            >
              <Icon>keyboard_arrow_left</Icon>
            </IconButton>
            <h4
              style={MONTH_LABEL_STYLE}
            >
              {monthLabel}
            </h4>
            <IconButton
              onClick={(_) => this.changeMonth(1)}
            >
              <Icon>keyboard_arrow_right</Icon>
            </IconButton>
          </div>
        </Paper>
        <div className="justify-c fullW">{this.GenerateAutoButton()}</div>
        {!generate && (
          <MaterialTable
            title=""
            isLoading={this.state.load}
            page={this.state.page || 0}
            columns={quitanceColumns}
            actions={this.getActions()}
            data={this.fetchQuitancesForTable}
            detailPanel={this.renderEtatPanel}
            onRowClick={this.rowClickNoop}
            options={this.listTableOptions}
            tableRef={this.listTableRef}
          />
        )}
        {generate && (
          <MaterialTable
            title=""
            isLoading={this.state.load || this.state.dossiersLoading}
            columns={quitanceGenerateColumns}
            data={this.getDossiersForMonth(startMonth, endMonth)}
            onRowClick={this.rowClickNoop}
            detailPanel={this.renderGenerateDetail}
            options={this.generateTableOptions}
            onSelectionChange={this.handleGenerateSelectionChange}
          />
        )}
        <div className="justify-c fullW">{this.GenerateAutoButton()}</div>
        <Dialog
          open={dialog ? true : false}
          onClose={(_) => this.setState({ dialog: false })}
        >
          <DialogTitle>{"Générer les quittances ?"}</DialogTitle>
          <DialogContent>
            {dialog.type === "auto" ? (
              <DialogContentText>
                Êtes vous sûr de vouloir bien valider la création de quittance
                automatiquement pour les dossiers sélectionnés. Cette action est
                irréversible et enverra des mails au propriétaire et locataire.
              </DialogContentText>
            ) : (
              <>
                <DialogContentText>
                  Êtes vous sûr de confirmer la quittance pour les informations
                  suivantes :
                </DialogContentText>
                <DialogContentText>{`date de début : ${moment(
                  dialog.date
                ).format("LL")}`}</DialogContentText>
                <DialogContentText>{`date de fin : ${moment(
                  dialog.dateFin
                ).format("LL")}`}</DialogContentText>
                <DialogContentText>{`loyer Hors charges : ${dialog.prixHC?.toFixed(
                  2
                )}€`}</DialogContentText>
                <DialogContentText>{`Charges: ${dialog.charge?.toFixed(
                  2
                )}€`}</DialogContentText>
                <DialogContentText>{`Loyer Total: ${(
                  dialog.charge + dialog.prixHC
                )?.toFixed(2)}€`}</DialogContentText>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(_) => {
                dialog.onClick();
                this.setState({ dialog: false });
              }}
              color="primary"
            >
              Confirmer
            </Button>
            <Button
              onClick={(_) => this.setState({ dialog: false })}
              color="primary"
              autoFocus
            >
              Annuler
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {},
});

const mapStateToProps = (state) => ({
  canDelete: state.reducer.canDelete,
});
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormList))
);
